var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { md: 24, sm: 24 } },
            [
              _c("el-card", { attrs: { shadow: "never" } }, [
                _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                  _c("span", { staticStyle: { "font-size": "20px" } }, [
                    _vm._v(
                      " 欢迎您~~~" +
                        _vm._s(_vm.userInfo.fullName) +
                        ", 欢迎使用上刊选点系统！"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", {
                  ref: "myChart",
                  staticStyle: { width: "100%", height: "600px" }
                })
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-387c8b72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-387c8b72","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dashboard/WorkPlace.vue
// module id = null
// module chunks = 